var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-stretch h-100",attrs:{"id":"article"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }